import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { studioInfo } from '../data/mock';
import { Menu, X, Globe } from 'lucide-react';

const Header = () => {
    const { t, language, toggleLanguage, isRTL } = useLanguage();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMobileMenuOpen(false);
    };

    return (
        <header
            className={` fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                isScrolled
                    ? 'bg-black/95 backdrop-blur-md shadow-lg'
                    : 'bg-black'
            }`}
        >
            <div className='mx-auto px-4 lg:px-8 max-w-7xl'>
                <div className='flex justify-between items-center h-20'>
                    {/* Logo */}
                    <div
                        className='flex items-center gap-3 py-3 cursor-pointer'
                        onClick={() => scrollToSection('home')}
                    >
                        <img
                            src={studioInfo.logo}
                            alt={studioInfo.name}
                            className='rounded-full size-12 object-contain'
                        />
                    </div>

                    {/* Desktop Navigation */}
                    <nav className='hidden md:flex items-center gap-8'>
                        {['home', 'about', 'gallery', 'contact'].map((item) => (
                            <button
                                key={item}
                                onClick={() => scrollToSection(item)}
                                className='group relative font-normal text-light-pink hover:text-white text-base transition-colors duration-200'
                            >
                                {t.nav[item]}
                                <span className='bottom-0 left-0 absolute bg-white w-0 group-hover:w-full h-0.5 transition-all duration-300' />
                            </button>
                        ))}
                    </nav>

                    {/* Language Toggle & Mobile Menu */}
                    <div className='flex items-center gap-4'>
                        <button
                            onClick={toggleLanguage}
                            className='flex items-center gap-2 hover:bg-light-pink/10 px-4 py-2 border border-light-pink/30 hover:border-light-pink rounded-full text-light-pink transition-all duration-300'
                            aria-label='Toggle language'
                        >
                            <Globe className='w-4 h-4' />
                            <span
                                style={{
                                    fontFamily: 'Arial',
                                }}
                                className='text-sm uppercase tracking-wider'
                            >
                                {language === 'en' ? 'עב' : 'EN'}
                            </span>
                        </button>

                        {/* Mobile Menu Button */}
                        <button
                            onClick={() =>
                                setIsMobileMenuOpen(!isMobileMenuOpen)
                            }
                            className='md:hidden p-2 text-white'
                            aria-label='Toggle menu'
                        >
                            {isMobileMenuOpen ? (
                                <X className='w-6 h-6' />
                            ) : (
                                <Menu className='w-6 h-6' />
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                <div
                    className={`md:hidden overflow-hidden transition-all duration-300 ${
                        isMobileMenuOpen ? 'max-h-64 pb-6' : 'max-h-0'
                    }`}
                >
                    <nav className='flex flex-col gap-4'>
                        {['home', 'about', 'gallery', 'contact'].map((item) => (
                            <button
                                key={item}
                                onClick={() => scrollToSection(item)}
                                className='font-normal text-light-pink hover:text-white text-lg text-start transition-colors duration-200'
                            >
                                {t.nav[item]}
                            </button>
                        ))}
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;
